import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/tr.ts
var add = "Ekle";
var remove = "Kaldır";
var removeAll = "Hepsini kaldır";
var incomplete = "Maalesef, tüm alanlar doğru doldurulmadı.";
var submit = "Gönder";
var noFiles = "Dosya yok";
var moveUp = "Yukarı Taşı";
var moveDown = "Aşağı taşı";
var isLoading = "Yükleniyor...";
var loadMore = "Daha fazla yükle";
var next = "Sonraki";
var prev = "Önceki";
var addAllValues = "Tüm değerleri ekle";
var addSelectedValues = "Seçili değerleri ekle";
var removeAllValues = "Tüm değerleri kaldır";
var removeSelectedValues = "Seçili değerleri kaldır";
var chooseDate = "Tarih seçin";
var changeDate = "Tarihi değiştir";
var close = "Kapat";
var open = "Açık";
var accepted = function({
  name
}) {
  return `Lütfen ${name}'yi kabul edin.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} ${date(args[0])}'den sonra olmalıdır.`;
  }
  return `${sentence(name)} gelecekte bir zaman olmalıdır.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} sadece alfabetik karakterler içerebilir.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} sadece alfabetik karakterler ve sayı içerebilir.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} yalnızca harf ve boşluk içerebilir.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} alfabetik karakterler içermelidir.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} harf veya rakamı içermelidir.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} harf veya boşluk içermelidir.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} sembol içermelidir.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} büyük harf içermelidir.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} küçük harf içermelidir.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} sayı içermelidir.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} bir sembol olmalıdır.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} yalnızca büyük harfler içerebilir.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} yalnızca küçük harfler içerebilir.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} ${date(args[0])} tarihinden önce olmalı.`;
  }
  return `${sentence(name)} geçmişte olmalı.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Alan yanlış yapılandırılmış ve gönderilemez.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} ${a} ve ${b} aralığında olmalı.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} eşleşmiyor.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} geçerli bir tarih değil, lütfen ${args[0]} biçimini kullanın.`;
  }
  return "Alan yanlış yapılandırılmış ve gönderilemez.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)}, ${date(args[0])} ve ${date(args[1])} aralığında olmalı.`;
};
var email = "Lütfen geçerli bir e-mail adresi girin.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} ${list(args)} ile bitmiyor.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} izin verilen bir değer değil.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} en azından bir karakter uzunluğunda olmalı.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} ${max2}'e eşit veya daha küçük olmalı.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} ${max2} karakter uzunluğunda olmalıdır.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} ${min2}'e eşit veya daha büyük olmalı.`;
  }
  return `${sentence(name)}, ${min2} ve ${max2} karakter uzunluğu aralığında olmalı.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} izin verilen bir değer değil.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${name}'in uzunluğu ${args[0]}'dan daha uzun olamaz.`;
  }
  return `${sentence(name)} en azından ${args[0]} uzunluğunda veya ona eşit olmalı.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Hiçbir dosya türüne izin verilmez.";
  }
  return `${sentence(name)} şu tiplerden biri olmalı: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${name}'in uzunluğu ${args[0]}'dan daha kısa olamaz.`;
  }
  return `${sentence(name)} en azından ${args[0]} uzunluğunda olmalı.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” ${name} olamaz.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} sayı olmalı.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" veya ")} gereklidir.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} gerekli.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} ${list(args)} ile başlamıyor.`;
};
var url = function() {
  return `Lütfen geçerli bir URL girin.`;
};
var invalidDate = "Seçilen tarih geçersiz.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var tr_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, tr_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=tr.mjs.map